<template>
  <div class="dashboard background">
    <date-picker v-model="startDate"
      element="startDate"></date-picker>
    <date-picker
      v-model="endDate"
      element="endDate"></date-picker>
    <date-picker
      v-model="payDate"
      element="payDate"></date-picker>
    <toast />
    <dashboard-page pcontent="1" page="COURSES">
      <!-- course manager  -->
      <card w='60%' minWidth='850px' v-if='true'>
        <!-- card header -->
        <div class='fRow fullWidth jStart aCenter' style="margin-bottom: 16px">
          <div class='growFull fCol jStart aStart'>
            <h3 class='growFull text-right'>فرم سنجش مشاورین</h3>
            <p class='note'>سؤالات فرم نظر سنجی را ایجاد یا به روز رسانی کنید.
            </p>
          </div>
          <btn isMini='true' label='به‌روز رسانی' bc='#667089'
            style="margin: 8px !important;"
            icon='sync' @click.native="backToCourse"/>
        </div>
        <div class="tabHeader fRow jStart aCenter fullWidth" id="tab"
          style="margin-bottom: 16px">
          <a @click="ratingForm = 'rateForm'"
            class="tabBtn fRow jCenter aCenter
            transition-fast" v-bind:class="{selected: ratingForm === 'rateForm'}">
            <i class="material-icons-round transition-fast">reorder</i>
            <span class="transition-fast">تعریف فرم نظر سنجی</span>
          </a>
          <a @click="ratingForm = 'getMoshaverRate'"
            class="tabBtn fRow jCenter aCenter
            transition-fast" v-bind:class="{selected: ratingForm === 'getMoshaverRate'}">
            <i class="material-icons-round transition-fast">support_agent</i>
            <span class="transition-fast">مشاهده‌ی اطلاعات مشاور</span>
          </a>
        </div>
        <!-- صفحه اضافه پلن به دانش آموز -->
        <div class="uploadersHolder fRow jBetween aCenter wrap fullWidth"
          v-if="isPayment && ratingForm === 'getMoshaverRate'">
          <div class="fCol jStart aCenter fullWidth assignmentForm">
            <!-- 1. select student -->
            <div class="fullWidth fRow jBetween aStart">
              <div class="fullWidth fRow jStart aCenter wrap formSection">
                <div class="rulesMini fullWidth fCol jStart aStart">
                  <label>انتخاب مشاور</label>
                  <span>بر اساس نام، شماره همراه</span>
                </div>
                <!-- filter -->
                <div class="fRow jBetween aCenter fullWidth">
                  <div class="fCol jStart aStart inputHolder growFull" style="margin-left: 8px">
                    <span class="fRow jStart aCenter">
                      <i class="material-icons-round">phone</i>
                      نام و نام خانوادگی یا شماره تماس مشاور را وارد کنید</span>
                    <div class="fRow jStart aCenter fullWidth inputWraper">
                      <input @keyup.enter="handleGetStudent"
                        class="transition-fast"
                        placeholder="نام و نام خانوادگی یا شماره تماس"
                        type="text" v-model="studentSearch">
                    </div>
                  </div>
                  <div class="b fRow jStart aCenter active"
                    @click="handleGetStudent"
                    style="margin-left: 0; margin-top: 13px">
                    <i class="material-icons-round">search</i>
                    <label>جستجو</label>
                  </div>
                </div>
                <!-- لیست دانش آموزان بعد از سرچ -->
                <div class="fullWidth fCol aCenter students">
                  <div class="fRow jStart aCenter fullWidth studentResult transition-medium"
                    v-bind:class="{selected: selectedStudent.studentId === item.studentId}"
                    v-for="(item, i) in searchedStudents" v-bind:key="i">
                    <div class="ava"></div>
                    <div class="fCol jCenter aStart stInfo">
                      <div class="stName">{{item.fullName}}</div>
                      <div class="stPhone">نام پدر: {{item.fatherFullName}}</div>
                    </div>
                    <div class="fCol jCenter aStart growFull">
                      <div class="stCode">{{item.mobile}}</div>
                      <div class="stCode">{{item.nationalCode}}</div>
                    </div>
                    <div class="b fRow jStart aCenter"
                      @click="selectedStudent = item">
                      <i class="material-icons-round">done_all</i>
                      <label>انتخاب</label>
                    </div>
                  </div>
                  <div class="noRes fCol jCenter aCenter"
                    v-if="searchedStudents.length === 0">
                    <i class="material-icons-round">cancel</i>
                    <span>دانش آموزی یافت نشد</span>
                  </div>
                </div>
              </div>
              <!-- فرم جستجوی دانش آموز -->
            </div>
            <!-- 2. add item to student -->
            <div class="fullWidth fRow jBetween aCenter wrap formSection"
              v-if="selectedStudent.studentId !== undefined">
              <div class="rulesMini fullWidth fCol jStart aStart">
                <label>{{`اضافه کردن برنامه‌ی ویژه به قرارداد  ${selectedStudent.fullName}`}}
                </label>
                <span>از بین گزینه‌های زیر انتخاب کنید</span>
              </div>
              <div class="fRow fullWidth jBetween aCenter" style="margin-bottom: 24px">
                <radio
                  v-for="(item, index) in extraPlans" v-bind:key="index"
                  :data="item"
                  class="w50"
                  :selected="selectedExtraPlans.indexOf(item.id) !== -1"
                  @click.native="selectExtraPlans(item.id)" />
              </div>
              <div class="fRow jStart aCenter fullWidth">
                <div class="b fRow jStart aCenter big"
                  v-bind:class="{active: selectedExtraPlans.length > 0}">
                  <i class="material-icons-round">done_all</i>
                  <label>ثبت برنامه‌ها</label>
                </div>
                <div class="b fRow jStart aCenter mini"
                  v-if="false"
                  @click="clearPaymentForm">
                  <i class="material-icons-round">delete</i>
                  <label>پاک کردن فرم</label>
                </div>
              </div>
            </div>
            <!-- فرم مشاهده آیتم های پرداخت -->
            <div class="fullWidth fRow jBetween aCenter wrap formSection"
              v-if="selectedStudent.studentId !== undefined && false">
              <div class="rulesMini fullWidth fCol jStart aStart">
                <label>{{`لیست پرداخت‌های ${selectedStudent.fullName}`}}
                </label>
                <!-- <span>ابتدا دانش آموز را انتخاب کنید</span> -->
              </div>
              <!-- payment -->
              <div class="mb fCol jStart aCenter fullWidth">
                <div class="paymentItem fullWidth fRow jBetween aCenter wrap"
                  v-for="(item, index) in studentPayments"
                  v-bind:key="index">
                  <!-- <div class="payIndex">{{index + 1}}</div> -->
                  <div class="fCol jStart aStart w40">
                    <div class="payTitle">{{item.type}}</div>
                    <div class="payAmount">{{commaSep(item.amount)}} تومان</div>
                    <div class="payDate">{{formatDate(item.date)}}</div>
                  </div>
                  <div class="payDesc fCol jCenter aStart">
                    <div class="inl">توضیحات پرداخت:</div>
                    {{item.description}}</div>
                </div>
                <div class="fullWidth fRow jCenter aCenter"
                  style="padding: 32px"
                  v-if="!paymentLoad">
                  لطفا صبر کنید...
                </div>
                <div class="fullWidth fRow jCenter aCenter"
                  style="padding: 32px"
                  v-if="paymentLoad && studentPayments.length === 0">
                  اطلاعاتی برای نمایش وجود ندارد
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- صفحه اضافه دانش آموز -->
        <div class="uploadersHolder fRow jBetween aCenter wrap fullWidth"
          v-if="isPayment && ratingForm === 'rateForm'">
          <div class="fCol jStart aCenter fullWidth assignmentForm">
            <div class="question fullWidth fCol jStart aCenter"
              v-for="(item, index) in rateFormQuestions" v-bind:key="index">
              <!-- .heads.fullWidth -->
              <div class="fCol jStart aStart inputHolder fullWidth">
                <span class="fRow jStart aCenter">
                  <i class="material-icons-round">question_mark</i>
                  متن سؤال {{index + 1}}</span>
                <div class="fRow jStart aCenter fullWidth inputWraper">
                  <textarea class="fullWidth"
                    :placeholder="`متن سؤال ${index + 1}`"
                    v-model="item.text"></textarea>
                </div>
              </div>
              <div class="options fullWidth jBetween aCenter fRow">
                <div class="fCol jStart aStart inputHolder w20"
                  v-for="(itm, indx) in item.options" v-bind:key="indx">
                  <span class="fRow jStart aCenter">
                    <i class="material-icons-round"
                      v-bind:class="{inpErr: itm.text.length === 0}">radio_button_checked</i>
                    متن گزینۀ {{indx + 1}}</span>
                  <div class="fRow jStart aCenter fullWidth inputWraper">
                    <input
                      class="transition-fast"
                      :placeholder="`متن گزینۀ ${indx + 1}`"
                      type="text" v-model="itm.text">
                  </div>
                </div>
              </div>
              <div class="fRow jEnd aCenter fullWidth">
                <div class="b fRow jStart aCenter mini"
                  @click="addNewRateQuestion(index)">
                  <i class="material-icons-round">add</i>
                  <label>اضافه کردن سؤال جدید</label>
                </div>
                <div class="b fRow jStart aCenter mini"
                  @click="removeRateQuestion(index)">
                  <i class="material-icons-round">add</i>
                  <label>حذف سؤال</label>
                </div>
              </div>
            </div>
            <div class="b fRow jStart aCenter"
              @click="addNewRateQuestion">
              <i class="material-icons-round">save</i>
              <label>ثبت سؤالات</label>
            </div>

          </div>
        </div>
        <!-- loading -->
        <div class="fCol jCenter aCenter fullWidth"
          v-if="loading || noContent">
          <p-bar
            :loading="loading"
            :notYet="notYet"
            :noContent="noContent"
            :notFound="notFound"
            :error="error" />
        </div>
      </card>
    </dashboard-page>
    <tool-bar/>
    <right-menu/>
    <modal v-if="modalShow">
      <card w="580px">
        <label class="question">با ترک این صفحه آپلودها متوقف می‌شوند.
          آیا مایل به ترک این صفحه هستید؟</label>
        <div class="fullWidth wrap aStart jStart fRow btnRow">
          <btn label="نمایش لیست ویدئوها" btnWidth='236px' bc='#ff0533'
          icon="delete_sweep" @click.native="showListAnyWay"/>
          <keep-alive>
            <btn fabBtn='true' label="بازگشت" btnWidth='auto'
              @click.native="closeModal" bc='#aaaaaa' icon="close"/>
          </keep-alive>
        </div>
      </card>
    </modal>
  </div>
</template>

<script>
import axios from 'axios';
import RightMenu from '@/components/RightMenu.vue';
import ToolBar from '@/components/ToolBar.vue';
import DashboardPage from '@/components/DashboardPage.vue';
import Card from '@/components/Card.vue';
import Btn from '@/components/Btn.vue';
import errorHandler from '@/mixins/mixin';
import makeToast from '@/mixins/makeToast';
import Toast from '@/components/Toast.vue';
import ticks from '@/mixins/ticks';
import Modal from '@/components/Modal.vue';
import Radio from '@/components/Radio.vue';
import moment from 'moment-jalaali';
// import Radio from '@/components/Radio.vue';
import pBar from '@/components/pBar.vue';
import 'vue-cool-select/dist/themes/material-design-dark.scss';
import '@/assets/new.scss';

export default {
  name: 'Rating',
  mixins: [errorHandler, makeToast, ticks],
  data() {
    return {
      baseURL: this.$store.state.baseUrl,
      V: this.$store.state.apiVersion,
      // modes ↓
      loading: false,
      noContent: false,
      notFound: false,
      error: false,
      notYet: false,
      loaded: true,
      modeMsg: '',
      // modes ↑
      // new pay array ↓
      payItemArray: [1],
      completedPayItems: [],
      // ↑
      isPayment: true,
      isAccounts: false,
      isReviewPayments: false,
      isConvention: false,
      isExamList: false,
      isBank: true,
      startDate: '',
      startDateShow: '',
      stErr: true,
      endDate: '',
      endDateShow: '',
      etErr: true,
      payMethods: [
        {
          id: 1,
          title: 'نقدی / پوز',
        },
        {
          id: 2,
          title: 'پرداخت کارت به کارت',
        },
        {
          id: 4,
          title: 'حساب به حساب',
        },
        {
          id: 3,
          title: 'پرداخت چکی',
        },
      ],
      payMethod: '',
      payMethodErr: true,
      notPayed: false,
      payDate: '',
      payDateShow: '',
      payDateErr: true,
      payAmount: '',
      payAmountErr: true,
      payDesc: '',
      payDescErr: true,
      questionBank: [
        {
          id: 0,
          title: 'لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ؟',
          img: '',
          level: 'easy',
        },
        {
          id: 1,
          title: 'کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد، کتابهای زیادی در شصت و سه درصد؟',
          img: 'https://api.rimik.ir/photo/4bb8eb17-2413-4497-9093-44f1ca691b79.jpg',
          level: 'hard',
        },
        {
          id: 2,
          title: 'کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد، کتابهای زیادی در شصت و سه درصد ؟',
          img: '',
          level: 'hard',
        },
        {
          id: 3,
          title: 'تمام و دشواری موجود در ارائه؟',
          img: '',
          level: 'normal',
        },
        {
          id: 4,
          title: 'شرایط سخت تایپ به پایان رسد و زمان مورد نیاز شامل حروفچینی دستاوردهای اصلی؟',
          img: '',
          level: 'hard',
        },
        {
          id: 5,
          title: 'جوابگوی سوالات پیوسته اهل دنیای موجود طراحی اساسا مورد استفاده قرار گیرد؟',
          img: '',
          level: 'easy',
        },
      ],
      // simple example of items
      fields: [
        {
          id: 0,
          title: 'متوسطه‌ی اول',
        },
        {
          id: 1,
          title: 'ریاضی',
        },
        {
          id: 2,
          title: 'تجربی',
        },
        {
          id: 3,
          title: 'انسانی',
        },
        {
          id: 4,
          title: 'فنی',
        },
        {
          id: 5,
          title: 'زبان',
        },
        {
          id: 6,
          title: 'هنر',
        },
      ],
      field: '',
      fieldErr: true,
      plans: [
        {
          id: 0,
          title: 'رشته را انتخاب کنید',
        },
      ],
      plan: '',
      planErr: true,
      conventions: [
        {
          id: 0,
          title: 'لیست مشاور از وب سرویس',
        },
      ],
      convention: '',
      conventionErr: true,
      // there will be a selected item
      fieldSelected: '',
      // other
      modalShow: false,
      name: '',
      nameErr: true,
      lastName: '',
      lastNameErr: true,
      // parents ↓
      father: '',
      fatherErr: true,
      fatherJob: '',
      fatherJobErr: true,
      fatherEdu: '',
      fatherEduErr: true,
      fatherPhone: '',
      fatherPhoneErr: true,
      mother: '',
      motherErr: true,
      motherJob: '',
      motherJobErr: true,
      motherEdu: '',
      motherEduErr: true,
      motherPhone: '',
      motherPhoneErr: true,
      // parents ↑
      melli: '',
      melliErr: true,
      studentPhone: '',
      studentPhoneErr: true,
      // convention form
      conventionName: '',
      adNameErr: true,
      conventionFamily: '',
      adFamilyErr: true,
      conventionPhone: 0,
      adPhoneErr: true,
      conventionsData: [],
      // pagination
      howManyPages: 0,
      pageSize: 10,
      activePage: 1,
      // اطلاعات دانش آموزان
      studentsList: [],
      sSearch: '',
      studentData: {
        firstName: 'مهدی',
        lastName: 'کاظمی',
      },
      // moasese
      company: [
        {
          name: 'ریمیک',
          icon: 'rimik',
          id: 0,
        },
        {
          name: 'هدف سازان',
          icon: 'rimik',
          id: 1,
        },
        {
          name: 'ورتــــا',
          icon: 'rimik',
          id: 2,
        },
        {
          name: 'دکتر بشیرپور',
          icon: 'rimik',
          id: 2,
        },
      ],
      selectedCompany: -1,
      // accounting
      payments: [],
      paymentLoad: false,
      banks: [{ id: 0, title: 'اقتصاد نوین' },
        { id: 1, title: 'انصار' },
        { id: 2, title: 'ایران زمین' },
        { id: 3, title: 'پارسیان' },
        { id: 3, title: 'پاسارگاد' },
        { id: 3, title: 'پست بانک' },
        { id: 3, title: 'تجارت' },
        { id: 3, title: 'توسعه تعاون' },
        { id: 3, title: 'توسعه صادرات ایران' },
        { id: 3, title: 'حکمت ایرانیان' },
        { id: 3, title: 'خاور میانه' },
        { id: 3, title: 'دی' },
        { id: 3, title: 'رسالت' },
        { id: 3, title: 'رفاع' },
        { id: 3, title: 'سامان' },
        { id: 3, title: 'سپه' },
        { id: 3, title: 'سرمایه' },
        { id: 3, title: 'سینا' },
        { id: 3, title: 'شهر' },
        { id: 3, title: 'صادرات' },
        { id: 3, title: 'صنعت و معدن' },
        { id: 3, title: 'قوامین' },
        { id: 3, title: 'کارآفرین' },
        { id: 3, title: 'کشاورزی' },
        { id: 3, title: 'گردشگری' },
        { id: 3, title: 'مسکن' },
        { id: 3, title: 'ملت' },
        { id: 3, title: 'ملی' },
        { id: 3, title: 'مهر' }],
      bank: '',
      banksSimple: ['اقتصاد نوین', 'انصار', 'ایران زمین', 'پارسیان', 'پاسارگاد', 'پست بانک', 'تجارت', 'توسعه تعاون', 'توسعه صادرات ایران', 'حکمت ایرانیان', 'خاور میانه', 'دی', 'رسالت', 'رفاع', 'سامان', 'سپه', 'سرمایه', 'سینا', 'شهر', 'صادرات', 'صنعت و معدن', 'قوامین', 'کارآفرین', 'کشاورزی', 'گردشگری', 'مسکن', 'ملت', 'ملی', 'مهر'],
      bankErr: true,
      gateWay: '',
      gateWayErr: true,
      gateWayNumber: '',
      gateWayNumberErr: true,
      gateWayDesc: '',
      gateWayDescErr: true,
      gateWayBank: '',
      gateWayBankErr: true,
      card: '',
      cardErr: false,
      accounts: [],
      // payment
      payAccounts: [],
      payAccount: '',
      payAccountErr: true,
      studentSearch: '',
      searchedStudents: [],
      selectedStudent: {},
      studentPayments: [],
      accountEditMode: false,
      accountEditData: {},
      // qests: [
      //   {
      //     id: 'asdadasdadasfwe',
      //     title: 'قسمت شماره یک',
      //     date: '2022-01-10T00:00',
      //     payed: true,
      //   },
      //   {
      //     id: 'asdasdasdasfwe',
      //     title: 'قسمت شماره دو',
      //     date: '2022-02-10T00:00',
      //     payed: false,
      //   },
      //   {
      //     id: 'asdadasdasdsfwe',
      //     title: 'قسمت شماره سه',
      //     date: '2022-03-10T00:00',
      //     payed: false,
      //   },
      //   {
      //     id: 'asdadaasdasfwe',
      //     title: 'قسمت شماره چهار',
      //     date: '2022-04-10T00:00',
      //     payed: false,
      //   },
      // ],
      selectedQest: {
        id: '',
      },
      payTypes: [
        {
          id: 2,
          title: 'سایر پرداخت‌ها',
        },
        {
          id: 1,
          title: 'پرداخت قسط',
        },
      ],
      payType: {
        id: 2,
      },
      qests: [],
      // review payments
      reviewSearch: '',
      reviewFilters: [
        {
          id: 0,
          title: 'همه‌ی پرداخت‌ها',
        },
        {
          id: 1,
          title: 'نیاز به بررسی',
        },
        {
          id: 2,
          title: 'تأیید شده‌ها',
        },
        {
          id: 3,
          title: 'تأیید نشده‌ها',
        },
      ],
      reviewFilter: 0,
      reviewItems: [
        {
          id: 'asdasdasdasvxcv',
          moshaverName: 'مهدی احمدی',
          desc: 'توضیحات پرداخت آیتم مهدی احمدی',
          status: 1,
        },
        {
          id: 'asdasdasasddasvxcv',
          moshaverName: 'ارشیا هندسی',
          desc: 'توضیحات پرداخت آیتم شیرین هادی',
          status: 1,
        },
        {
          id: 'asdasdasdasdasvxcv',
          moshaverName: 'رضا محمدی',
          desc: 'توضیحات پرداخت آیتم رضا محمدی',
          status: 2,
        },
        {
          id: 'asdasdasdasvxasd546cv',
          moshaverName: 'شیرین هادی',
          desc: 'توضیحات پرداخت آیتم شیرین هادی',
          status: 3,
        },
      ],
      // extra plan datas
      extraPlan: 0,
      extraPlans: [
        {
          id: 1,
          title: 'کلاس نکته و تست',
          desc: 'کلاس نکته و تست',
        },
        {
          id: 2,
          title: 'اردوی عید نوروز',
          desc: 'اردوی عید نوروز',
        },
      ],
      selectedExtraPlans: [],
      ratingForm: 'getMoshaverRate',
      rateFormQuestions: [
        {
          id: 'asdasdasd',
          text: 'متن سؤال اول',
          options: [
            {
              id: 'qwedasczxcfdfsdf',
              text: 'خیلی ضعیف',
            },
            {
              id: 'qwedasczxscfdfsdf',
              text: 'خیلی ضعیف',
            },
            {
              id: 'qwedassczxcfdfsdf',
              text: 'معمولی',
            },
            {
              id: 'qwedasczxcfdfasdf',
              text: 'خوب',
            },
            {
              id: 'qwaedasczxcfdfsdf',
              text: 'خیلی خوب',
            },
          ],
        },
      ],
    };
  },
  methods: {
    addNewRateQuestion(index) {
      this.rateFormQuestions.splice(index + 1, 0,
        {
          id: `${(Math.random() * 1000).toFixed(0)}`,
          text: '',
          options: [
            {
              id: `${(Math.random() * 1000).toFixed(0)}`,
              text: '',
            },
            {
              id: `${(Math.random() * 1000).toFixed(0)}`,
              text: '',
            },
            {
              id: `${(Math.random() * 1000).toFixed(0)}`,
              text: '',
            },
            {
              id: `${(Math.random() * 1000).toFixed(0)}`,
              text: '',
            },
            {
              id: `${(Math.random() * 1000).toFixed(0)}`,
              text: '',
            },
          ],
        });
    },
    selectExtraPlans(id) {
      const ind = this.selectedExtraPlans.indexOf(id);
      if (ind === -1) {
        this.selectedExtraPlans.push(id);
      } else {
        this.selectedExtraPlans.splice(ind, 1);
      }
    },
    addNewPayItem() {
      // console.warn('add new pay item');
      this.payItemArray.push(1);
    },
    itemChanged(e) {
      // اگر این آیتم
      const a = this.isItemInArray(e.index);
      if (a !== -1) {
        this.completedPayItems.splice(a, 0);
      }
      // console.warn(this.completedPayItems);
    },
    getResult(e) {
      if (e !== false) {
        const a = this.isItemInArray(e.index);
        if (a === -1) {
          this.completedPayItems.push(e);
        } else {
          this.completedPayItems[a] = e;
        }
      }
      // console.warn(this.completedPayItems);
    },
    deleteFromArray(e) {
      const a = this.isItemInArray(e);
      if (a !== -1) {
        this.completedPayItems.splice(a, 1);
      }
    },
    isItemInArray(index) {
      let a = -1;
      for (let i = 0; i < this.completedPayItems.length; i += 1) {
        if (this.completedPayItems[i].index === index) {
          a = i;
          break;
        }
      }
      return a;
    },
    setMode(m, msg) {
      this.noContent = false;
      this.loading = false;
      this.notYet = false;
      this.error = false;
      this.loaded = false;
      this.modeMsg = '';
      switch (m) {
        case 'loading': {
          this.loading = true;
          break;
        }
        case 'loaded': {
          this.loaded = true;
          break;
        }
        case 'error': {
          this.modeMsg = msg;
          this.error = true;
          break;
        }
        case 'notYet': {
          this.notYet = true;
          break;
        }
        case 'noContent': {
          this.noContent = true;
          break;
        }
        default:
          break;
      }
    },
    backToCourse() {
      this.$store.commit('resetCourseObject');
      this.$router.push('/courses');
    },
    getTeacherPhoto() {
      const reqUrl = `${this.baseURL}/api/v${this.V}/Teachers/${this.teacherId}`;
      axios({
        method: 'get',
        url: reqUrl,
        headers: {
          Authorization: this.$authObeject.authToken(),
        },
      }).then((response) => {
        this.posts = response.data;
        if (this.posts.isSuccess) {
          // console.log(this.posts);
          this.teacherImg = this.posts.data.user.avatar;
        } else {
          this.responseFalse = true;
        }
      }, (error) => {
        this.makeToast('error', this.errorHandler(error), 3000);
      });
    },
    addNewUploader() {
      // alert(event);
      this.isVideoUploading = true;
      this.uploaderCount += 1;
      this.uploaderArray.push(this.uploaderCount.toString());
    },
    closeModal() {
      this.modalShow = false;
    },
    showListAnyWay() {
      this.isVideoUploading = false;
      this.modalShow = false;
      this.toggleSection('list');
    },
    toggleSection(order) {
      this.isPayment = false;
      this.isAccounts = false;
      this.isReviewPayments = false;
      switch (order) {
        case 'payments': {
          this.isPayment = true;
          // this.handleGetStudent();
          break;
        }
        case 'accounts': {
          this.isAccounts = true;
          this.getAccounts();
          break;
        }
        case 'review': {
          this.isReviewPayments = true;
          this.getAccounts();
          break;
        }
        default:
          break;
      }
    },
    selected(e, dropDown) {
      switch (dropDown) {
        case 'field': {
          // console.log(this.field.id);
          const a = this.field.id;
          if (a === 0 || a === 4 || a === 6) {
            this.plans = [
              {
                id: 1,
                title: 'A+ طرح طلایی',
              },
              {
                id: 2,
                title: 'A طرح طلایی',
              },
              {
                id: 3,
                title: 'B طرح نقره‌ای',
              },
              {
                id: 4,
                title: 'C طرح برنزی',
              },
            ];
          } else {
            this.plans = [
              {
                id: 2,
                title: 'A طرح طلایی',
              },
              {
                id: 3,
                title: 'B طرح نقره‌ای',
              },
              {
                id: 4,
                title: 'C طرح برنزی',
              },
            ];
          }
          this.fieldErr = false;
          this.plan = '';
          this.planErr = true;
          break;
        }
        case 'plan': {
          // console.log(this.plan.id);
          this.planErr = false;
          break;
        }
        case 'payMethod': {
          // console.log(this.payMethod.id);
          this.payMethodErr = false;
          if (this.payMethod.id === 4) {
            this.notPayed = true;
            this.payDate = '';
          } else {
            this.notPayed = false;
          }
          break;
        }
        case 'payAccount': {
          this.payAccountErr = false;
          if (this.payMethod.id === 4) {
            this.notPayed = true;
            this.payDate = '';
          } else {
            this.notPayed = false;
          }
          break;
        }
        default:
          break;
      }
    },
    commaSep(number) {
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    GoToPages(event) {
      if (event === 'next') {
        // alert('next');
        this.activePage += 1;
        if (this.activePage > this.howManyPages) {
          this.activePage = 1;
        }
        this.getStudents(this.activePage);
        return;
      }
      if (event === 'prev') {
        this.activePage -= 1;
        if (this.activePage < 1) {
          this.activePage = this.howManyPages;
        }
        this.getStudents(this.activePage);
        return;
      }
      this.getStudents(event);
      this.activePage = event;
    },
    handleGetStudent() {
      let s = this.studentSearch.replace(/ك/g, 'ک');
      s = this.studentSearch.replace(/ي/g, 'ی');
      const reqUrl = `${this.baseURL}/api/v${this.V}/Students/search?search=${s}`;
      axios({
        method: 'get',
        url: reqUrl,
        headers: {
          Authorization: this.$authObeject.authToken(),
        },
      }).then((response) => {
        if (response.data.isSuccess) {
          const r = response.data.data;
          this.searchedStudents = r;
          // console.log(r);
        } else {
          this.makeToast('error', response.data.message, 3000);
        }
      }, (error) => {
        this.makeToast('error', this.errorHandler(error), 3000);
        // console.log(error);
      }).catch(() => {
        this.paymentLoad = false;
        this.makeToast('error', 'در صورت درستی اتصال به اینترنت، با تیم فنی تماس بگیرید', 3000);
      });
    },
    getStudents(p) {
      this.setMode('loading');
      let tpage = 1;
      if (p !== undefined) {
        tpage = p;
      }
      // eslint-disable-next-line
      let reqUrl = `${this.baseURL}/api/v${this.V}/Users/students?pageNo=${tpage}&pageSize=${this.pageSize}`;
      // const url = 'https://api.rimik.ir/api/v1/Users/studnets?pageNo=1&pageSize=10';
      axios({
        method: 'get',
        url: reqUrl,
        headers: {
          Authorization: this.$authObeject.authToken(),
        },
      }).then((response) => {
        if (response.data.isSuccess) {
          this.studentsList = response.data.data.students;
          this.howManyPages = response.data.data.pageCount;
          this.setMode('loaded');
        } else {
          this.makeToast('error', 'خطا در بارگذاری', 3000);
          this.setMode('error', 'خطا در بارگذاری');
        }
      }, (error) => {
        this.makeToast('error', this.errorHandler(error), 3000);
        // console.log(error);
      });
    },
    getStudentsSearch(p) {
      this.setMode('loading');
      let tpage = 1;
      if (p !== undefined) {
        tpage = p;
      }
      // eslint-disable-next-line
      let reqUrl = `${this.baseURL}/api/v${this.V}/Users/student/search?pageNo=${tpage}&pageSize=${this.pageSize}&search=${this.sSearch}`;
      // const url = 'https://api.rimik.ir/api/v1/Users/studnets?pageNo=1&pageSize=10';
      axios({
        method: 'get',
        url: reqUrl,
        headers: {
          Authorization: this.$authObeject.authToken(),
        },
      }).then((response) => {
        if (response.data.isSuccess) {
          this.studentsList = response.data.data.students;
          this.howManyPages = response.data.data.pageCount;
          this.setMode('loaded');
        } else {
          this.makeToast('error', 'خطا در بارگذاری', 3000);
          this.setMode('error', 'خطا در بارگذاری');
        }
      }, (error) => {
        this.makeToast('error', this.errorHandler(error), 3000);
        // console.log(error);
      });
    },
    resetPageSize(e) {
      this.pageSize = e;
      this.activePage = 1;
      this.getStudents();
    },
    getConventions() {
      this.setMode('loading');
      this.conventions = [{
        title: 'لطفا صبر کنید',
        id: '',
      }];
      const reqUrl = `${this.baseURL}/api/v${this.V}/Conventions/consultant`;
      axios({
        method: 'get',
        url: reqUrl,
        headers: {
          Authorization: this.$authObeject.authToken(),
        },
      }).then((response) => {
        if (response.data.isSuccess) {
          this.conventions = [];
          const arr = response.data.data;
          if (arr.length === 0) {
            this.setMode('noContent');
            // ریست کردن لیست ها
            this.conventions = [{
              title: 'طبقه‌بندی ثبت نشده',
              id: '',
            }];
          } else {
            for (let i = 0; i < arr.length; i += 1) {
              this.conventions.push({
                id: arr[i].id,
                title: arr[i].fullName,
              });
            }
            this.conventionsData = response.data.data;
            // console.log('----', this.conventionsData);
            this.setMode('loaded');
          }
        } else {
          this.responseFalse = true;
        }
      }, (error) => {
        this.makeToast('error', this.errorHandler(error), 3000);
        this.setMode('error', this.errorHandler(error));
        // console.log(error);
      }).catch(() => {
        this.setMode('error', 'در صورت درستی اتصال اینترنت، با تیم فنی تماس بگیرید');
      });
    },
    newConventions() {
      if (this.isConventionReady) {
        const reqUrl = `${this.baseURL}/api/v${this.V}/Conventions/consultant`;
        axios({
          method: 'post',
          url: reqUrl,
          headers: {
            Authorization: this.$authObeject.authToken(),
          },
          data: {
            firstName: this.conventionName,
            lastName: this.conventionFamily,
            phoneNumber: `98${this.conventionPhone.slice(1, 11)}`,
          },
        }).then((response) => {
          if (response.data.isSuccess) {
            this.getConventions();
            this.makeToast('success', 'تفاهم‌نامه جدید با موفقیت ثبت شد', 3000);
            this.clearConsultantForm();
          } else {
            this.makeToast('error', response.data.message, 3000);
          }
        }, (error) => {
          this.makeToast('error', `${this.errorHandler(error)}`, 3000);
          // console.log(error);
        }).catch(() => {
          this.makeToast('error', 'در صورت درستی اتصال به اینترنت، با تیم فنی تماس بگیرید', 3000);
        });
      } else {
        this.makeToast('error', 'ابتدا فرم را تکمیل کنید', 3000);
      }
    },
    newStudent() {
      if (this.isFormReady) {
        const reqUrl = `${this.baseURL}/api/v${this.V}/Users/student`;
        axios({
          method: 'post',
          url: reqUrl,
          headers: {
            Authorization: this.$authObeject.authToken(),
          },
          data: {
            firstName: this.name,
            lastName: this.lastName,
            phoneNumber: this.studentPhone.replace('09', '989'),
            fatherName: this.father,
            nationalCode: this.melli,
            planType: this.plan.title,
            startTheContract: this.startDate,
            endTheContract: this.endDate,
            field: this.field.id,
            consultantId: this.convention.id,
            paymentType: this.notPayed ? null : this.payMethod.title,
            paymentAmount: this.notPayed ? null : this.payAmount.replace(/,/g, ''),
            paymentDate: this.notPayed ? '0001-01-01T00:00:00' : this.payDate,
            paymentDescription: this.notPayed ? null : this.payDesc,
          },
        }).then((response) => {
          if (response.data.isSuccess) {
            this.getConventions();
            this.makeToast('success', 'تفاهم‌نامه‌ی جدید با موفقیت ثبت شد', 3000);
            this.clearStudentForm();
          } else {
            this.makeToast('error', response.data.message, 3000);
          }
        }, (error) => {
          this.makeToast('error', `${this.errorHandler(error)}. درستی شماره را بررسی نمایید`, 3000);
          // console.log(error);
        }).catch(() => {
          this.makeToast('error', 'در صورت درستی اتصال به اینترنت، با تیم فنی تماس بگیرید', 3000);
        });
      } else {
        this.makeToast('error', 'ابتدا فرم را تکمیل کنید', 3000);
      }
    },
    clearStudentForm() {
      this.name = '';
      this.lastName = '';
      this.studentPhone = '';
      this.father = '';
      this.melli = '';
      this.field = '';
      this.plan = '';
      this.convention = '';
      this.startDate = '';
      this.endDate = '';
      this.payMethod = '';
      this.payDate = '';
      this.payAmount = '';
      this.payDesc = '';
    },
    clearConsultantForm() {
      this.conventionName = '';
      this.conventionFamily = '';
      this.conventionPhone = '';
    },
    // getPayments
    getPayment() {
      this.paymentLoad = false;
      const reqUrl = `${this.baseURL}/api/v${this.V}/Payments/${this.data.userId}`;
      axios({
        method: 'get',
        url: reqUrl,
        headers: {
          Authorization: this.$authObeject.authToken(),
        },
      }).then((response) => {
        this.paymentLoad = true;
        if (response.data.isSuccess) {
          this.payments = response.data.data;
        } else {
          this.makeToast('error', response.data.message, 3000);
        }
      }, (error) => {
        this.paymentLoad = true;
        this.makeToast('error', this.errorHandler(error), 3000);
        // console.log(error);
      }).catch(() => {
        this.paymentLoad = false;
        this.makeToast('error', 'در صورت درستی اتصال به اینترنت، با تیم فنی تماس بگیرید', 3000);
      });
    },
    // get student payments
    getStudentPayments() {
      this.paymentLoad = false;
      // eslint-disable-next-line
      const reqUrl = `${this.baseURL}/api/v${this.V}/Financials/payment/${this.selectedStudent.userId}`;
      axios({
        method: 'get',
        url: reqUrl,
        headers: {
          Authorization: this.$authObeject.authToken(),
        },
      }).then((response) => {
        this.paymentLoad = true;
        if (response.data.isSuccess) {
          this.studentPayments = [];
          this.studentPayments = response.data.data;
          // console.log(this.studentPayments);
        } else {
          this.makeToast('error', response.data.message, 3000);
        }
      }, (error) => {
        this.paymentLoad = true;
        this.makeToast('error', this.errorHandler(error), 3000);
        // console.log(error);
      }).catch(() => {
        this.paymentLoad = false;
        this.makeToast('error', 'در صورت درستی اتصال به اینترنت، با تیم فنی تماس بگیرید', 3000);
      });
    },
    // new payment for student
    newPayment() {
      if (this.completedPayItems.length > 0) {
        const d = {
          studentId: this.selectedStudent.studentId,
          payments: this.completedPayItems,
        };
        const reqUrl = `${this.baseURL}/api/v${this.V}/Financials/payment`;
        axios({
          method: 'post',
          url: reqUrl,
          headers: {
            Authorization: this.$authObeject.authToken(),
          },
          data: d,
        }).then((response) => {
          if (response.data.isSuccess) {
            // console.log(response.data);
            this.getAccounts();
            this.getStudentPayments();
            this.clearPaymentForm();
          } else {
            this.makeToast('error', response.data.message, 3000);
          }
        }, (error) => {
          this.makeToast('error', this.errorHandler(error), 3000);
          // console.log(error);
        }).catch(() => {
          this.makeToast('error', 'در صورت درستی اتصال به اینترنت، با تیم فنی تماس بگیرید', 3000);
        });
      } else {
        this.makeToast('error', 'فرم را تکمیل کنید', 3000);
      }
    },
    newAccount() {
      if (this.isAccountFormReady) {
        const reqUrl = `${this.baseURL}/api/v${this.V}/Financials/account`;
        axios({
          method: 'post',
          url: reqUrl,
          headers: {
            Authorization: this.$authObeject.authToken(),
          },
          data: {
            name: this.gateWay,
            number: this.gateWayNumber,
            bank: this.gateWayBank,
            card: this.card,
            status: true,
            description: this.gateWayDesc,
          },
        }).then((response) => {
          if (response.data.isSuccess) {
            // console.log(response.data);
            this.getAccounts();
            this.clearAccountForm();
          } else {
            this.makeToast('error', response.data.message, 3000);
          }
        }, (error) => {
          this.makeToast('error', this.errorHandler(error), 3000);
          // console.log(error);
        }).catch(() => {
          this.makeToast('error', 'در صورت درستی اتصال به اینترنت، با تیم فنی تماس بگیرید', 3000);
        });
      } else {
        this.makeToast('error', 'فرم را تکمیل کنید', 3000);
      }
    },
    editAccount() {
      if (this.isAccountFormReady) {
        const reqUrl = `${this.baseURL}/api/v${this.V}/Financials/account/${this.accountEditData.id}`;
        axios({
          method: 'put',
          url: reqUrl,
          headers: {
            Authorization: this.$authObeject.authToken(),
          },
          data: {
            name: this.gateWay,
            number: this.gateWayNumber,
            bank: this.gateWayBank,
            card: this.card,
            description: this.gateWayDesc,
          },
        }).then((response) => {
          if (response.data.isSuccess) {
            // console.log(response.data);
            this.getAccounts();
            this.clearAccountForm();
          } else {
            this.makeToast('error', response.data.message, 3000);
          }
        }, (error) => {
          this.makeToast('error', this.errorHandler(error), 3000);
          // console.log(error);
        }).catch(() => {
          this.makeToast('error', 'در صورت درستی اتصال به اینترنت، با تیم فنی تماس بگیرید', 3000);
        });
      } else {
        this.makeToast('error', 'فرم را تکمیل کنید', 3000);
      }
    },
    getAccounts() {
      this.accounts = [];
      this.payAccounts = [
        {
          id: -1,
          title: 'کمی صبر کنید...',
        },
      ];
      this.setMode('loading');
      const reqUrl = `${this.baseURL}/api/v${this.V}/Financials/account`;
      axios({
        method: 'get',
        url: reqUrl,
        headers: {
          Authorization: this.$authObeject.authToken(),
        },
      }).then((response) => {
        this.setMode('loaded');
        if (response.data.isSuccess) {
          this.accounts = response.data.data;
          this.payAccounts = [];
          for (let i = 0; i < this.accounts.length; i += 1) {
            const a = {
              id: this.accounts[i].id,
              title: this.accounts[i].name,
              bank: this.accounts[i].bank,
            };
            this.payAccounts.push(a);
          }
          // console.log(this.payAccounts);
        } else {
          this.makeToast('error', response.data.message, 3000);
        }
      }, (error) => {
        this.setMode('error', this.errorHandler(error));
        this.makeToast('error', this.errorHandler(error), 3000);
        // console.log(error);
      }).catch((error) => {
        this.errorHandler(error);
        this.setMode('error');
        this.makeToast('error', 'در صورت درستی اتصال به اینترنت، با تیم فنی تماس بگیرید', 3000);
      });
    },
    clearAccountForm() {
      this.gateWayDesc = '';
      this.gateWayBank = '';
      this.gateWayNumber = '';
      this.gateWay = '';
      this.card = '';
      this.accountEditMode = false;
    },
    clearPaymentForm() {
      this.payAccount = '';
      this.payAccountErr = true;
      this.payMethod = '';
      this.payMethodErr = true;
      this.payAmount = '';
      this.payAmountErr = true;
      this.payDate = '';
      this.payDateErr = true;
      this.payDesc = '';
      this.payDescErr = true;
      this.completedPayItems = [];
      this.payItemArray = [];
      setTimeout(() => {
        this.payItemArray = [1];
      }, 100);
    },
    // format date
    formatDate(d) {
      return moment(d, 'YYYY-MM-DDTHH:mm:ss')
        .locale('fa')
        .format('dddd, jDD jMMMM jYYYY');
    },
    initEdit(e) {
      // console.log(e);
      this.accountEditData = e;
      this.accountEditMode = true;
      this.gateWay = e.name;
      this.gateWayNumber = e.number;
      this.card = e.card;
      this.gateWayDesc = e.description;
      this.gateWayBank = e.bank;
    },
  },
  components: {
    RightMenu,
    ToolBar,
    DashboardPage,
    Card,
    Btn,
    Toast,
    Modal,
    pBar,
    // Radio,
    Radio,
  },
  watch: {
    fieldSelected() {
    },
    name() {
      if (this.name.length === 0) {
        this.nameErr = true;
      } else if (this.name.length > 24) {
        this.name = this.name.substr(0, 24);
        this.nameErr = false;
      } else {
        this.nameErr = false;
      }
    },
    lastName() {
      if (this.lastName.length === 0) {
        this.lastNameErr = true;
      } else if (this.lastName.length > 24) {
        this.lastName = this.lastName.substr(0, 24);
        this.lastNameErr = false;
      } else {
        this.lastNameErr = false;
      }
    },
    father() {
      if (this.father.length === 0) {
        this.fatherErr = true;
      } else if (this.father.length > 40) {
        this.father = this.father.substr(0, 40);
        this.fatherErr = false;
      } else {
        this.fatherErr = false;
      }
    },
    fatherJob() {
      if (this.fatherJob.length === 0) {
        this.fatherJobErr = true;
      } else if (this.fatherJob.length > 40) {
        this.fatherJob = this.fatherJob.substr(0, 40);
        this.fatherJobErr = false;
      } else {
        this.fatherJobErr = false;
      }
    },
    fatherEdu() {
      if (this.fatherEdu.length === 0) {
        this.fatherEduErr = true;
      } else if (this.fatherEdu.length > 40) {
        this.fatherEdu = this.fatherEdu.substr(0, 40);
        this.fatherEduErr = false;
      } else {
        this.fatherEduErr = false;
      }
    },
    fatherPhone() {
      const phonePattern = /^\(?([0-9]{4})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
      if (this.fatherPhone.length > 11) {
        this.fatherPhone = this.fatherPhone.substr(0, 11);
        // console.log(this.message);
        this.fatherPhoneErr = false;
      }
      if (this.fatherPhone.match(phonePattern)
        && this.fatherPhone.charAt(0) === '0'
        && this.fatherPhone.charAt(1) === '9') {
        this.fatherPhoneErr = false;
      } else {
        this.fatherPhoneErr = true;
      }
    },
    mother() {
      if (this.mother.length === 0) {
        this.motherErr = true;
      } else if (this.mother.length > 40) {
        this.mother = this.mother.substr(0, 40);
        this.motherErr = false;
      } else {
        this.motherErr = false;
      }
    },
    motherJob() {
      if (this.motherJob.length === 0) {
        this.motherJobErr = true;
      } else if (this.motherJob.length > 40) {
        this.motherJob = this.motherJob.substr(0, 40);
        this.motherJobErr = false;
      } else {
        this.motherJobErr = false;
      }
    },
    motherEdu() {
      if (this.motherEdu.length === 0) {
        this.motherEduErr = true;
      } else if (this.motherEdu.length > 40) {
        this.motherEdu = this.motherEdu.substr(0, 40);
        this.motherEduErr = false;
      } else {
        this.motherEduErr = false;
      }
    },
    motherPhone() {
      const phonePattern = /^\(?([0-9]{4})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
      if (this.motherPhone.length > 11) {
        this.motherPhone = this.motherPhone.substr(0, 11);
        // console.log(this.message);
        this.motherPhoneErr = false;
      }
      if (this.motherPhone.match(phonePattern)
        && this.motherPhone.charAt(0) === '0'
        && this.motherPhone.charAt(1) === '9') {
        this.motherPhoneErr = false;
      } else {
        this.motherPhoneErr = true;
      }
    },
    melli() {
      if (this.melli.length === 10) {
        this.melliErr = false;
      } else if (this.melli.length > 10) {
        this.melli = this.melli.substr(0, 10);
        this.melliErr = false;
      } else {
        this.melliErr = true;
      }
    },
    startDate() {
      if (this.startDate !== '') {
        // console.log('date', this.startDate);
        this.startDateShow = moment(this.startDate, 'YYYY-MM-DDTHH:mm')
          .locale('FA')
          .format('jDD jMMMM jYYYY');
        this.stErr = false;
      } else {
        this.startDateShow = '';
        this.stErr = true;
      }
    },
    endDate() {
      if (this.endDate !== '') {
        // console.log('date', this.endDate);
        this.endDateShow = moment(this.endDate, 'YYYY-MM-DDTHH:mm')
          .locale('FA')
          .format('jDD jMMMM jYYYY');
        this.etErr = false;
      } else {
        this.endDateShow = '';
        this.etErr = true;
      }
    },
    payDate() {
      if (this.payDate !== '') {
        // console.log('date', this.payDate);
        this.payDateShow = moment(this.payDate, 'YYYY-MM-DDTHH:mm')
          .locale('FA')
          .format('jDD jMMMM jYYYY');
        this.payDateErr = false;
      } else {
        this.payDateErr = true;
        this.payDateShow = '';
      }
    },
    payAmount() {
      let p = this.payAmount;
      p = p.replace(/,/g, '');
      if (!/^\d+$/.test(p) || (p.charAt(0) === '0' || p.charAt(0) === 0)) {
        p = p.substr(0, p.length - 1);
      }
      if (p.length > 12) {
        this.payAmount = this.payAmount.substr(0, 12);
      }
      p = this.commaSep(p);
      this.payAmount = p;
      if (this.payAmount.length > 3) {
        this.payAmountErr = false;
      } else {
        this.payAmountErr = true;
      }
    },
    payDesc() {
      if (this.payDesc.length === 0) {
        this.payDescErr = true;
      } else if (this.payDesc.length > 128) {
        this.payDesc = this.payDesc.substr(0, 128);
        this.payDescErr = false;
      } else {
        this.payDescErr = false;
      }
    },
    conventionName() {
      if (this.conventionName.length === 0) {
        this.adNameErr = true;
      } else if (this.conventionName.length > 24) {
        this.conventionName = this.conventionName.substr(0, 24);
        this.adNameErr = false;
      } else {
        this.adNameErr = false;
      }
    },
    conventionFamily() {
      if (this.conventionFamily.length === 0) {
        this.adFamilyErr = true;
      } else if (this.conventionFamily.length > 24) {
        this.conventionFamily = this.conventionFamily.substr(0, 24);
        this.adFamilyErr = false;
      } else {
        this.adFamilyErr = false;
      }
    },
    conventionPhone() {
      const phonePattern = /^\(?([0-9]{4})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
      if (this.conventionPhone.length > 11) {
        this.conventionPhone = this.conventionPhone.substr(0, 11);
        // console.log(this.message);
        this.adPhoneErr = false;
      }
      if (this.conventionPhone.match(phonePattern)
        && this.conventionPhone.charAt(0) === '0'
        && this.conventionPhone.charAt(1) === '9') {
        this.adPhoneErr = false;
      } else {
        this.adPhoneErr = true;
      }
    },
    studentPhone() {
      const phonePattern = /^\(?([0-9]{4})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
      if (this.studentPhone.length > 11) {
        this.studentPhone = this.studentPhone.substr(0, 11);
        // console.log(this.message);
        this.studentPhoneErr = false;
      }
      if (this.studentPhone.match(phonePattern)
        && this.studentPhone.charAt(0) === '0'
        && this.studentPhone.charAt(1) === '9') {
        this.studentPhoneErr = false;
      } else {
        this.studentPhoneErr = true;
      }
    },
    isAccounts() {
    },
    // accounting
    gateWay() {
      this.gateWayErr = this.gateWay === ''
        || this.gateWay === null
        || this.gateWay === undefined
        || this.gateWay.length < 3;
    },
    gateWayNumber() {
      this.gateWayNumber = this.gateWayNumber.substr(0, 30);
      this.gateWayNumberErr = this.gateWayNumber === ''
        || this.gateWayNumber === null
        || this.gateWayNumber === undefined
        || this.gateWayNumber.length < 3;
    },
    gateWayBank() {
      this.gateWayBankErr = this.gateWayBank === ''
        || this.gateWayBank === null;
    },
    gateWayDesc() {
      this.gateWayDescErr = this.gateWayDesc === ''
        || this.gateWayDesc === null
        || this.gateWayDesc === undefined
        || this.gateWayDesc.length < 8;
    },
    card() {
      // let a = false;
      if (this.card === null) {
        this.card = '';
      }
      this.card = this.card.substr(0, 16);
      this.cardErr = this.card.length > 0 && this.card.length < 16;
    },
    // payment
    selectedStudent() {
      // console.log(this.selectedStudent);
      if (this.selectedStudent.installments === null) {
        this.qests = [];
      } else {
        this.qests = this.selectedStudent.installments;
      }
      this.clearPaymentForm();
      if (this.selectedStudent.userId !== undefined) {
        this.getStudentPayments();
      }
    },
  },
  computed: {
    isPayReady() {
      let a = false;
      if (this.notPayed) {
        // a = !this.payAmountErr
        //   && !this.payMethodErr
        //   && !this.payDescErr;
        a = true;
      } else {
        a = !this.payDateErr
          && !this.payAmountErr
          && !this.payMethodErr
          && !this.payDescErr;
      }
      return a;
    },
    isFormReady() {
      const a = !this.nameErr
        && !this.lastNameErr
        && !this.fatherErr
        && !this.melliErr
        && !this.stErr
        && !this.etErr
        && !this.fieldErr
        && !this.planErr
        && this.isPayReady;
      return a;
    },
    isConventionReady() {
      const a = !this.adNameErr
        && !this.adFamilyErr
        && !this.adPhoneErr;
      return a;
    },
    isAccountFormReady() {
      return !this.gateWayErr
        && !this.gateWayNumberErr
        && !this.gateWayBankErr
        && !this.gateWayDescErr;
    },
    filteredAccounts() {
      // eslint-disable-next-line
      return this.accounts.filter((item) => item.name.toLowerCase().includes(this.sSearch.toLowerCase())
        || item.bank.toLowerCase().includes(this.sSearch.toLowerCase())
        || item.bank.toLowerCase().includes(`بانک ${this.sSearch.toLowerCase()}`)
        || item.description.toLowerCase().includes(this.sSearch.toLowerCase()));
    },
    isNewPaymentReady() {
      return !this.payDescErr
        && !this.payAmountErr
        && !this.payDateErr
        && !this.payAccountErr
        && !this.payMethodErr;
    },
  },
  mounted() {
    this.$store.commit('setLoadingOff');
    this.toggleSection('payments');
    this.getAccounts();
    const a = this.$store.state.accountingInfo;
    if (a !== {}) {
      // alert('from student row');
      this.studentSearch = a.mobile;
      this.handleGetStudent();
    } else {
      // new
    }
  },
  beforeDestroy() {
    this.$store.commit('clearAccounting');
  },
};
</script>

<style lang="scss" scoped>
$azadSecondary: #8e9bd6;
$azadPrimary: #2156ae;
$azadNormalText: #343434;
$azadDarkText: #131313;
$azadInvertText: #fafafa;
// new for exam ↓↓↓
.bank {
  margin-top: 16px;
  .bankList {
    width: 380px;
    min-height: 312px;
    border-radius: 4px;
    overflow: hidden;
    box-shadow: 0 0 16px 0 rgba($color: #000000, $alpha: 0.05),
      0 8px 8px 0 rgba($color: #000000, $alpha: 0.1);
    span.h {
      padding: 16px;
      border-bottom: 1px dashed rgba(0, 0, 0, 0.11);
    }
    .filterBox {
      padding: 8px;
    }
    ul {
      padding: 0;
      margin: 0;
      li {
        list-style-type: none;
        padding: 16px;
        border-bottom: 1px solid rgba($color: #000000, $alpha: 0.05);
        .qindex {
          width: 24px;
          min-width: 24px;
          font-size: 10px;
          font-weight: 300;
          text-align: right;
        }
        .qQuestion {
          span.q {
            font-size: 13px;
            font-weight: 200;
            text-align: right;
          }
          i {
            margin-left: 8px;
            opacity: 0.5;
            transition: all ease-in-out 0.3s;
          }
          i:hover {
            opacity: 1;
          }
          i.hard {
            color: rgb(206, 0, 0);
          }
          i.normal {
            color: rgb(27, 190, 49);
          }
          i.easy {
            color: rgb(54, 101, 161);
          }
        }
        .qAddToList {
          width: 32px;
          min-width: 32px;
          margin-right: 16px;
          i {
            font-size: 16px;
          }
        }
      }
      li:hover {
        background-color: rgba($color: #000000, $alpha: 0.05);
        border-bottom: 1px solid rgba($color: #000000, $alpha: 0.0);
      }
    }
  }
}
// new for exam ↑↑↑
  .counter{
    min-width: 96px;
    label{
      font-weight: bold;
      margin-right: 8px;
      font-size: 32px;
      color: rgba($color: #363636, $alpha: 1.0);
    }
    span{
      font-weight: 100;
      font-size: 12px;
      color: rgba($color: #363636, $alpha: 1.0);
    }
  }
  .courseInfoHolder {
    $iw: 204px;
    padding: 24px;
    margin-bottom: 24px;
    border-bottom: dashed 1px rgba($color: #000000, $alpha: 0.2);
    img.c{
      width: $iw;
      height: $iw;
      border-radius: 8px;
    }
    .courseTeacher{
      font-size: 16px;
      word-spacing: -2px;
      font-weight: 400;
    }
    .courseLesson{
      font-size: 13px;
      word-spacing: 0px;
      font-weight: 400;
    }
    .courseName{
      font-size: 28px;
      word-spacing: -2px;
      font-weight: 400;
      color: #61187A;
      text-align: right;
      line-height: 1.3;
      border-right: solid 4px rgba($color: #61187A, $alpha: 1);
      padding: 0px 8px 0 0;
    }
  }
  .assignments {
    box-shadow: 0 8px 16px 0 rgba($color: #000000, $alpha: 0.15);
    border-radius: 8px;
    overflow: hidden;
    .heads {
      width: 100%;
      text-align: right;
      padding: 8px;
      word-spacing: -2px;
      font-size: 14px;
      color: rgba($color: white, $alpha: 1.0);
      font-weight: 400;
      background-color: #61187A;
      i {
        margin-left: 8px;
        font-size: 16px;
        color: #f0f0f0;
        padding: 8px;
      }
    }
    ul {
      padding: 0;
      margin: 0;
      max-width: 480px;
      overflow: hidden auto;
      li {
        width: 100%;
        padding: 12px;
        list-style: none;
        text-align: right;
        span {
          width: 16px;
          font-size: 10px;
          font-weight: 200;
          text-align: right;
        }
        .title {
          font-size: 14px;
          font-weight: bold;
        }
        .desc {
          font-size: 10px;
          font-weight: 300;
        }
      }
    }
  }

  .infos{
    padding: 0 24px;
  }
  .courseId{
    padding: 2px 8px;
    font-size: 10px;
    margin-bottom: 16px;
    letter-spacing: 2px;
    border-right: solid 4px rgba($color: #000000, $alpha: 0.2);
  }
  .courseSummary{
    padding: 8px 8px 16px;
    font-size: 12px;
    text-align: right;
    color: #646464;
    border-right: solid 4px rgba($color: #000000, $alpha: 0.2);
  }

  .teacherHolder img.t{
    width: 64px;
    height: 64px;
    margin-left: 8px;
    border-radius: 80px 0 80px 80px;
  }

  .question{
    font-size: 18px;
    font-weight: 300;
    margin-bottom: 16px;
    text-align: right;
  }

  .ltr {
    direction: ltr !important;
  }
  .rules{
    margin: 24px 24px 50px;
  }

  .formSection {
    padding: 16px;
    padding-top: 0;
    margin-bottom: 8px;
    border: solid 2px rgba($color: #000000, $alpha: 0.1);
    border-radius: 16px;
    .students {
      max-height: 256px;
      overflow: hidden auto;
      padding: 0 16px;
      .studentResult {
        padding: 8px;
        border-radius: 8px;
        margin-bottom: 8px;
        box-shadow: 0 2px 8px -4px rgba($color: #000000, $alpha: 0.25);
        border: solid rgba(0, 0, 0, 0.05) 2px;
        .ava {
          width: 32px;
          height: 32px;
          border-radius: 50%;
          background-color: rgba($color: #000000, $alpha: 0.05);
          margin-left: 8px;
        }
        .stName {
          font-weight: bold;
          font-size: 15px;
        }
        .stPhone {
          font-size: 12px;
          font-weight: 200;
        }
        .stCode {
          font-weight: 200;
          letter-spacing: 2px;
          padding: 0 24px 0 26px;
          margin-right: 8px;
          font-size: 12px;
        }
      }
      .studentResult.selected {
        border-color: rgba($color: #58af5c, $alpha: 1.0) !important;
      }
      .noRes {
        padding: 32px;
        i {
          font-size: 48px;
          color: rgba($color: #000000, $alpha: 0.25);
          margin-bottom: 16px;
        }
        span {
          font-size: 16px;
          font-weight: 200;
          color: rgba($color: #000000, $alpha: 0.45);
        }
      }
    }
}

  .ruleBox {
    padding: 0 8px;
  }

  .uploadersHolder h3, .videoList h3 {
    width: 100%;
    text-align: right;
    padding: 8px 16px;
    word-spacing: -2px;
    font-size: 16px;
    font-weight: 400;
  }
  .uploadersHolder h4, .videoList h4 {
    width: 100%;
    text-align: right;
    padding: 8px 16px;
    word-spacing: -2px;
    font-size: 14px;
    font-weight: 200;
    position: relative;
  }

  .uploadersHolder h4::before, .videoList h4::before{
    position: absolute;
    content: ' ';
    border-radius: 50%;
    width: 8px;
    height: 8px;
    background-color: royalblue;
    left: calc(100% - 8px);
    top: 50%;
    transform: translateY(-50%);
  }

  .uploadersHolder p, .videoList p {
    width: 100%;
    text-align: right;
    padding: 0px 16px;
    word-spacing: -1px;
    font-size: 12px;
    font-weight: 200;
    margin: 0 0 4px 0;
    position: relative;
  }

  .uploadersHolder p::before, .videoList p::before{
    position: absolute;
    content: ' ';
    border-radius: 50%;
    width: 8px;
    height: 8px;
    background-color: rgba(65, 105, 225, 0.301);
    left: calc(100% - 8px);
    top: 5px;
  }

  input[type="text"], input[type='number'] {
    border-radius: 8px;
    border: solid 1px rgba($color: #000000, $alpha: 0.05);
    padding: 4px 8px;
    font-size: 13px;
    font-weight: 200;
    width: 100%;
  }

  // n
  .formHead {
    padding: 8px 0px;
    margin-bottom: 8px;
    border-right: solid 2px rgba($color: #000000, $alpha: 0.25);
    i {
      color: blue;
      margin-left: 8px;
    }
    span {
      font-size: 14px;
      font-weight: bold;
      text-align: right;
    }
  }

  .companies {
    .company {
      padding: 8px;
      border-radius: 8px;
      border: solid 2px rgba($color: $azadSecondary, $alpha: 0.25);
      margin-bottom: 4px;
      .companyIcon {
        width: 40px;
        height: 40px;
        margin-left: 8px;
        border-radius: 8px;
        background-color: rgba($color: #000000, $alpha: 0.05);
      }
      span {
        font-size: 10px;
      }
      .companyName {
        font-weight: bold;
        font-size: 14px;
        line-height: 1;
      }
    }
    .company:hover {
      border: solid 2px rgba($color: $azadSecondary, $alpha: 0.45);
    }
    .company.selected {
      border: solid 2px rgba($color: $azadSecondary, $alpha: 1);
      .companyIcon {
        background-color: rgba($color: #000000, $alpha: 0.15);
      }
    }
  }

  .paymentItem {
    padding: 8px;
    border-radius: 16px;
    .payIndex {
      width: 24px;
      text-align: center;
      font-size: 10px;
      font-weight: bold;
    }
    .payTitle {
      font-size: 16px;
    }
    .payAmount {
      font-size: 14px;
      font-weight: bold;
    }
    .payDate {
      font-size: 12px;
    }
    .payDesc {
      .inl {
        font-size: 10px;
        color: rgba($color: #000000, $alpha: 0.25);
      }
      padding: 8px;
      width: calc(60%) !important;
      height: 100%;
      font-size: 12px;
      border-right: dashed 1px rgba($color: #000000, $alpha: 0.1);
      background-color: rgba($color: #000000, $alpha: 0.0);
    }
  }
  .paymentItem:nth-child(2n+1) {
    background-color: rgba($color: #000000, $alpha: 0.05);
  }
  .ti {
    text-align: right;
    font-size: 14px;
    padding-right: 16px;
    margin-bottom: 16px;
    border-right: solid 4px rgba($color: #000000, $alpha: 0.5);
  }
  .question {
    padding: 16px 16px 8px 16px;
    border-radius: 16px;
    border: solid 1px rgba($color: #000000, $alpha: 0.15);
    .input {
      margin-bottom: 0 !important;
    }
  }
</style>
